import { FormattedMessage } from 'react-intl'
import LuxPlusLogo from './Logos/LuxPlusLogo'
import { useAppSelector } from 'hooks/reduxHooks'
import { getAvailableBookingProtectionBenefits } from 'luxPlus/selectors/benefits/bookingProtection'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  logoHeight: number
  saveAmount: number
}

function LuxPlusBookingProtectionLabelLabel(props: Props) {
  const { logoHeight, saveAmount } = props
  const luxPlusBookingProtectionBenefitView = useAppSelector(getAvailableBookingProtectionBenefits)
  const showBookingProtectionPercentage = saveAmount < luxPlusBookingProtectionBenefitView.luxPlusDiscountValueDisplayThreshold

  const luxPlusLogo = <LuxPlusLogo colour="inherit" height={logoHeight} />

  const percentageLabel = <FormattedMessage
    id="Ow2ZAW58OnpJOxIsKosW"
    defaultMessage="Save up to {percentage}% with {logo}"
    
    values={{ percentage: luxPlusBookingProtectionBenefitView.luxPlusDiscountPercentage, logo: luxPlusLogo }}
  />

  const currencyLabel = <FormattedMessage
    id="vQ0MEE5eoVuu4_A5HIHb"
    defaultMessage="Save {saveAmount} with {logo}"
    
    values={{ saveAmount: <FormatCurrency value={saveAmount} format="roundedDollar" />, logo: luxPlusLogo }}
  />

  return <>{showBookingProtectionPercentage ? percentageLabel : currencyLabel}</>
}

export default LuxPlusBookingProtectionLabelLabel
